/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PricingCategoryQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PricingCategoryQueryOperator");
    }

    getFixupPrototypeFunction() { return PricingCategoryQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PricingCategoryQueryOperator>): PricingCategoryQueryOperator {
        let obj = Object.assign(new PricingCategoryQueryOperator(), model);
        PricingCategoryQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PricingCategoryQueryOperator>): PricingCategoryQueryOperator {
        if (!model) return null;
        return PricingCategoryQueryOperator.newInstance(<PricingCategoryQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PricingCategoryQueryOperator) {
        if (!obj) return;

        models.PricingCategoryQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PricingCategoryQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PricingCategoryQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Pricing categories to include
     */
    pricing_categories: Array<string>;

}
